module.exports = __webpack_public_path__ + "static/media/heart12.d0bf4fe4.svg";